import { createPinia } from 'pinia';

// Create and export the Pinia instance
const pinia = createPinia();

export default pinia;
